/* Prestige-inspired theme — interactions */
(function () {
  'use strict';

  /* Mobile drawer */
  function initDrawer() {
    var burger = document.querySelector('[data-drawer-open]');
    var drawer = document.querySelector('[data-drawer]');
    if (!burger || !drawer) return;
    var close = drawer.querySelector('[data-drawer-close]');
    var overlay = drawer.querySelector('.drawer__overlay');
    function open() { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function shut() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    burger.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    if (overlay) overlay.addEventListener('click', shut);
  }

  /* Scroll reveal */
  function revealAll(scope) {
    (scope || document).querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    // In the theme editor (or when IntersectionObserver is unavailable) show everything immediately
    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || !els.length) {
      revealAll();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  // Theme editor: reveal newly-loaded/edited sections so content never stays hidden
  document.addEventListener('shopify:section:load', function (e) { revealAll(e.target); });

  /* Simple slideshow */
  function initSlideshow() {
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var slides = root.querySelectorAll('.hero__slide');
      if (slides.length < 2) return;
      var i = 0;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      slides.forEach(function (s, idx) { s.style.display = idx === 0 ? '' : 'none'; });
      setInterval(function () {
        slides[i].style.display = 'none';
        i = (i + 1) % slides.length;
        slides[i].style.display = '';
      }, interval);
    });
  }

  /* Product variant -> update price & hidden id */
  function initProductForm() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var data = form.querySelector('[data-variants]');
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var idInput = form.querySelector('[name="id"]');
      var priceEl = form.querySelector('[data-price]');
      var selects = form.querySelectorAll('[data-option]');
      function update() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.find(function (v) {
          return v.options.every(function (o, idx) { return o === chosen[idx]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initReveal();
    initSlideshow();
    initProductForm();
  });
})();

/* ============================================================
   Imported homepage sections — interactions
   ============================================================ */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* Countdown timers */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var deadline = new Date((el.getAttribute('data-deadline') || '').replace(/-/g, '/')).getTime();
      if (isNaN(deadline)) return;
      var d = el.querySelector('[data-days]'), h = el.querySelector('[data-hours]'),
          m = el.querySelector('[data-mins]'), s = el.querySelector('[data-secs]');
      function tick() {
        var diff = deadline - Date.now();
        if (diff < 0) diff = 0;
        var dd = Math.floor(diff / 864e5),
            hh = Math.floor(diff % 864e5 / 36e5),
            mm = Math.floor(diff % 36e5 / 6e4),
            ss = Math.floor(diff % 6e4 / 1e3);
        if (d) d.textContent = pad(dd); if (h) h.textContent = pad(hh);
        if (m) m.textContent = pad(mm); if (s) s.textContent = pad(ss);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* Generic tabs (best sellers) */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === i); });
        });
      });
    });
  }

  /* Timeline year tabs */
  function initTimeline() {
    document.querySelectorAll('[data-timeline]').forEach(function (root) {
      var years = root.querySelectorAll('[data-year]');
      var panels = root.querySelectorAll('[data-panel]');
      years.forEach(function (y) {
        y.addEventListener('click', function () {
          var i = y.getAttribute('data-year');
          years.forEach(function (t) { t.classList.toggle('is-active', t === y); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === i); });
        });
      });
    });
  }

  /* Product carousel arrows */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-track]');
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      if (!track) return;
      function step() { var cell = track.querySelector('.carousel__cell'); return cell ? cell.offsetWidth + 26 : 300; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* Lookbook slider */
  function initLookbooks() {
    document.querySelectorAll('[data-lookbook]').forEach(function (root) {
      var slides = root.querySelectorAll('.lookbook__slide');
      var dots = root.querySelectorAll('[data-dot]');
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var i = 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-dot'), 10)); }); });
    });
  }

  /* Product of the week gallery + qty */
  function initPotw() {
    document.querySelectorAll('[data-gallery]').forEach(function (root) {
      var frames = root.querySelectorAll('[data-frame]');
      var dots = root.querySelectorAll('[data-dot]');
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = dot.getAttribute('data-dot');
          frames.forEach(function (f) { f.classList.toggle('is-active', f.getAttribute('data-frame') === i); });
          dots.forEach(function (d) { d.classList.toggle('is-active', d === dot); });
        });
      });
    });
    document.querySelectorAll('.qty').forEach(function (qty) {
      var input = qty.querySelector('[data-qty]');
      var minus = qty.querySelector('[data-qty-minus]');
      var plus = qty.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });
  }

  /* Before/after compare slider */
  function initCompare() {
    document.querySelectorAll('[data-compare]').forEach(function (root) {
      var before = root.querySelector('[data-before]');
      var handle = root.querySelector('[data-handle]');
      if (!before || !handle) return;
      var dragging = false;
      function setPos(x) {
        var rect = root.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, (x - rect.left) / rect.width * 100));
        before.style.width = pct + '%';
        handle.style.left = pct + '%';
      }
      function start(e) { dragging = true; move(e); }
      function move(e) { if (!dragging) return; var x = e.touches ? e.touches[0].clientX : e.clientX; setPos(x); }
      function end() { dragging = false; }
      handle.addEventListener('mousedown', start);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      handle.addEventListener('touchstart', start, { passive: true });
      window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('touchend', end);
    });
  }

  /* Video modal */
  function initVideo() {
    document.querySelectorAll('[data-video-banner]').forEach(function (root) {
      var open = root.querySelector('[data-video-open]');
      var modal = root.querySelector('[data-video-modal]');
      if (!open || !modal) return;
      var iframe = modal.querySelector('iframe');
      var src = iframe ? iframe.getAttribute('src') : null;
      open.addEventListener('click', function () { modal.hidden = false; document.body.style.overflow = 'hidden'; });
      modal.querySelectorAll('[data-video-close]').forEach(function (c) {
        c.addEventListener('click', function () {
          modal.hidden = true; document.body.style.overflow = '';
          if (iframe && src) iframe.setAttribute('src', src); /* stop playback */
        });
      });
    });
  }

  /* Scroll-down cue */
  function initScrollCue() {
    document.querySelectorAll('[data-scroll-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var hero = btn.closest('.hero');
        var target = hero && hero.parentElement ? hero.nextElementSibling : null;
        var top = target ? target.getBoundingClientRect().top + window.pageYOffset : window.innerHeight;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdowns();
    initTabs();
    initTimeline();
    initCarousels();
    initLookbooks();
    initPotw();
    initCompare();
    initVideo();
    initScrollCue();
  });
})();

/* ============================================================
   Product page — gallery + variant swatches
   ============================================================ */
(function () {
  'use strict';

  function initProductPage() {
    var product = document.querySelector('.product');
    if (!product) return;

    var form = product.querySelector('.product__form');
    if (!form) return;
    var dataEl = form.querySelector('[data-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-price]');
    var atc = form.querySelector('.product__atc');
    var picks = Array.prototype.slice.call(form.querySelectorAll('.vpick'));
    if (!picks.length) return;

    function gotoMedia(i) {
      var g = product.querySelector('[data-product-gallery]');
      if (g && typeof g.goToMedia === 'function') g.goToMedia(i);
    }
    function selectedValues() {
      return picks.map(function (p) {
        var active = p.querySelector('.vpick__swatch.is-active');
        return active ? active.getAttribute('data-value') : null;
      });
    }
    function update() {
      var chosen = selectedValues();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      picks.forEach(function (p) {
        var active = p.querySelector('.vpick__swatch.is-active');
        var lbl = p.querySelector('[data-selected-label]');
        if (active && lbl) lbl.textContent = active.getAttribute('data-value');
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? (atc.getAttribute('data-label') || atc.textContent) : 'Sold out';
      }
      if (match.media != null) gotoMedia(match.media);
    }
    form.querySelectorAll('.vpick__swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var group = sw.closest('.vpick__values');
        group.querySelectorAll('.vpick__swatch').forEach(function (x) { x.classList.remove('is-active'); });
        sw.classList.add('is-active');
        update();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initProductPage);
})();

/* Newsletter popup */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.querySelector('[data-popup]');
    if (!popup) return;
    var key = 'prestige_popup_seen';
    try { if (localStorage.getItem(key)) return; } catch (e) {}
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 4000;
    function open() { popup.hidden = false; }
    function close() {
      popup.hidden = true;
      try { localStorage.setItem(key, '1'); } catch (e) {}
    }
    setTimeout(open, delay);
    popup.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });
})();

/* ============================================================
   Sticky header + AJAX cart drawer (settings-driven)
   ============================================================ */
(function () {
  'use strict';

  /* Sticky header shadow / solidify */
  function initSticky() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    function onScroll() { header.classList.toggle('is-stuck', window.pageYOffset > 40); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Cart drawer */
  function initCart() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var isDrawer = document.body.classList.contains('cartmode-drawer');
    if (!isDrawer || !drawer) return;

    var currency = drawer.getAttribute('data-currency') || 'USD';
    var threshold = parseInt(drawer.getAttribute('data-threshold'), 10) || 0;
    var showBar = drawer.getAttribute('data-free-bar') === 'true';
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var subEl = drawer.querySelector('[data-cart-subtotal]');
    var barWrap = drawer.querySelector('[data-cart-bar]');

    function money(cents) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format((cents || 0) / 100); }
      catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
    }
    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + n + ')'; });
    }
    function open() { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); document.body.style.overflow = 'hidden'; refresh(); }
    function close() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { drawer.hidden = true; }, 400); }

    function render(cart) {
      setCount(cart.item_count);
      if (subEl) subEl.textContent = money(cart.total_price);
      if (showBar && barWrap) {
        var msg = barWrap.querySelector('[data-bar-msg]');
        var fill = barWrap.querySelector('[data-bar-fill]');
        if (threshold > 0) {
          var remain = threshold - cart.total_price;
          if (remain > 0) { msg.textContent = "You're " + money(remain) + " away from free shipping"; fill.style.width = Math.min(100, cart.total_price / threshold * 100) + '%'; }
          else { msg.textContent = "🎉 You've unlocked free shipping!"; fill.style.width = '100%'; }
        }
      }
      if (!cart.items.length) { itemsEl.innerHTML = ''; if (emptyEl) emptyEl.hidden = false; return; }
      if (emptyEl) emptyEl.hidden = true;
      itemsEl.innerHTML = cart.items.map(function (it, i) {
        var line = i + 1;
        var img = it.image ? '<img class="cart-item__img" src="' + it.image.replace(/(\.[^.]+)$/, '_160x$1') + '" alt="" width="64" height="80">' : '<span class="cart-item__img"></span>';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cart-item__variant">' + it.variant_title + '</div>' : '';
        return '<div class="cart-item" data-line="' + line + '">' + img +
          '<div><div class="cart-item__title">' + it.product_title + '</div>' + variant +
          '<div class="cart-item__qty"><button type="button" data-minus>&minus;</button><span>' + it.quantity + '</span><button type="button" data-plus>+</button></div></div>' +
          '<div class="cart-item__right">' + money(it.final_line_price) + '<br><button type="button" class="cart-item__remove" data-remove>Remove</button></div></div>';
      }).join('');
    }

    function refresh() { fetch('/cart.js').then(function (r) { return r.json(); }).then(render); }
    function change(line, qty) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(render);
    }

    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line]'); if (!row) return;
      var line = parseInt(row.getAttribute('data-line'), 10);
      var qtyEl = row.querySelector('.cart-item__qty span');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.hasAttribute('data-plus')) change(line, qty + 1);
      else if (e.target.hasAttribute('data-minus')) change(line, Math.max(0, qty - 1));
      else if (e.target.hasAttribute('data-remove')) change(line, 0);
    });

    var note = drawer.querySelector('[data-cart-note]');
    if (note) note.addEventListener('change', function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    });

    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* Intercept add-to-cart forms -> AJAX + open drawer */
    document.querySelectorAll('form[action$="/cart/add"], form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.dataset.t = btn.textContent; btn.textContent = 'Adding…'; }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.t; } open(); })
          .catch(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.t; } form.submit(); });
      });
    });

    refresh();
  }

  document.addEventListener('DOMContentLoaded', function () { initSticky(); initCart(); });
})();

/* ============================================================
   Predictive search overlay
   ============================================================ */
(function () {
  'use strict';
  function initSearch() {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    var input = modal.querySelector('[data-search-input]');
    var results = modal.querySelector('[data-search-results]');
    var openers = document.querySelectorAll('[data-search-open]');
    var closers = modal.querySelectorAll('[data-search-close]');
    var timer, controller;

    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 50);
    }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }

    openers.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    function render(products, query) {
      if (!products.length) {
        results.innerHTML = '<p class="search-modal__empty">No results for "' + query.replace(/</g, '') + '"</p>';
        return;
      }
      var html = products.map(function (p) {
        var src = p.image || p.featured_image || (p.featured_media && p.featured_media.preview_image && p.featured_media.preview_image.src) || '';
        var img = src ? '<img class="search-result__img" src="' + src + '" alt="" width="56" height="70" loading="lazy">' : '<span class="search-result__img"></span>';
        var pr = p.price || p.price_min || '';
        var price = pr ? '<span class="search-result__price">' + pr + '</span>' : '';
        return '<a class="search-result" href="' + p.url + '">' + img +
          '<span class="search-result__title">' + p.title + '</span>' + price + '</a>';
      }).join('');
      html += '<a class="search-modal__all" href="/search?q=' + encodeURIComponent(query) + '&type=product">View all results</a>';
      results.innerHTML = html;
    }

    function search(q) {
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(function () {});
    }

    function empty(msg) { results.innerHTML = '<p class="search-modal__empty">' + msg + '</p>'; }
    empty('Start typing to search');
    if (input) input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { empty('Start typing to search'); return; }
      empty('Searching\u2026');
      timer = setTimeout(function () { search(q); }, 250);
    });
  }
  document.addEventListener('DOMContentLoaded', initSearch);
})();